import { useQuery } from '@tanstack/react-query'
import { companyFilesKey } from './keys'
import { useAuthContext } from 'components/auth'
import {
  getCompanyFiles,
  GetCompanyFilesRequest,
} from 'api/company/companyFiles'
import { useCompanyInfo } from './useCompanyInfo'

export function useCompanyFiles(
  query: Omit<GetCompanyFilesRequest, 'companyId'>
) {
  const { isAuthenticated } = useAuthContext()
  const { data: company } = useCompanyInfo()

  return useQuery({
    placeholderData: { files: [] },
    queryKey: companyFilesKey,
    /** @ts-expect-error fn is only enabled if company.id is defined */
    queryFn: () => getCompanyFiles({ ...query, companyId: company?.id }),
    enabled: Boolean(isAuthenticated && company?.id),
    staleTime: 1000 * 60 * 5, // 5 minutes
    select: (data) => data.files,
  })
}
